import React, { useEffect, useState } from 'react';
import { motion, Variants } from 'framer-motion';
import { supabase } from '@/integrations/supabase/client';

export function FarmhouseExperience() {
  const [content, setContent] = useState({
    exp_eyebrow: 'PRIVATE FARMHOUSE EXPERIENCE',
    exp_headline: 'Relaxing Farmhouse Retreat',
    exp_description: 'Experience a serene getaway in our farmhouse with three cozy rooms and a refreshing pool.'
  });

  useEffect(() => {
    const fetchContent = async () => {
      const { data } = await supabase
        .from('page_content')
        .select('key, content')
        .in('key', ['exp_eyebrow', 'exp_headline', 'exp_description']);
      
      if (data) {
        const newContent = { ...content };
        data.forEach(item => {
          if (item.key in newContent) {
            newContent[item.key as keyof typeof content] = item.content;
          }
        });
        setContent(newContent);
      }
    };
    fetchContent();
  }, []);

  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1] as any,
      },
    },
  };

  return (
    <section id="experiences" className="py-24 lg:py-40 bg-background overflow-hidden">
      <div className="max-w-screen-xl mx-auto px-6 text-center">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="flex flex-col items-center"
        >
          <motion.div variants={itemVariants} className="flex flex-col items-center mb-10">
            <span className="font-serif !text-[#176B5B] mb-4 uppercase tracking-widest text-sm">
              {content.exp_eyebrow}
            </span>
            <div className="w-16 h-[1px] !bg-[#B8863B]/30" />
          </motion.div>

          <motion.div variants={itemVariants} className="relative mb-12 px-4">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-32 h-[1px] bg-gradient-to-r from-transparent via-accent/20 to-transparent" />
            
            <h2 className="heading-luxury max-w-[90vw] md:max-w-4xl mx-auto font-bold !text-[#176B5B] font-serif">
              {content.exp_headline}
            </h2>
            
            <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-32 h-[1px] bg-gradient-to-r from-transparent via-accent/20 to-transparent" />
          </motion.div>

          <motion.p 
            variants={itemVariants}
            className="font-clean text-base md:text-lg leading-relaxed max-w-2xl mx-auto mt-4 px-4 !text-[#59635C]"
          >
            {content.exp_description}
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
